import React from 'react';
import '../styles/Hours.css';

function Hours() {
  const hours = [
    { day: 'Lunes', time: '09:00–20:00', highlight: false },
    { day: 'Martes', time: '11:00–21:30', highlight: true },
    { day: 'Miércoles', time: '09:00–20:00', highlight: false },
    { day: 'Jueves', time: '11:00–21:30', highlight: true },
    { day: 'Viernes', time: '09:00–20:00', highlight: false },
    { day: 'Sábado', time: '09:00–15:00', highlight: false },
    { day: 'Domingo', time: 'Cerrado', highlight: false, closed: true }
  ];

  return (
    <div className="hours">
      <div className="section-title">
        <h2>Horarios</h2>
      </div>
      <div className="hours-grid">
        {hours.map((item, index) => (
          <div className={`hours-item ${item.highlight ? 'highlight' : ''}`} key={index}>
            <div className="day">{item.day}</div>
            <div className={`time ${item.closed ? 'closed' : ''}`}>{item.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Hours;